"use strict";

exports.__esModule = true;
exports.formatUserName = formatUserName;
function formatUserName(_ref) {
  var username = _ref.username,
    profile = _ref.profile;
  if (profile && profile.name) {
    return profile.name.first || profile.name.last ? profile.name.first + " " + profile.name.last : username;
  }
  return username;
}